<template>
    <div>
        <v-card>
            <v-toolbar flat color="info" height="40">
                <v-toolbar-title>{{title}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- <v-btn icon color="primary" @click.prevent="closeSendEmail()">
                    <v-icon>clear</v-icon>
                </v-btn> -->
            </v-toolbar>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs2 sm1>To</v-flex>
                    <v-flex xs10 text-xs-left>

                        <v-chip v-for="email in initEmailSendingData.toEmails"
                            :key="email.email"
                            close
                            @input="removeToEmail(email)"
                        >{{email.name}}<{{email.email}}></v-chip>
                        
                    </v-flex>
                    <v-flex offset-xs2 offset-sm1 xs4 >
                        <v-btn 
                            color="primary"
                            small
                            href="#"
                            @click.prevent="addToEmail=true; showUserPicker=true">
                            Pick Exists User
                        </v-btn>
                        <v-btn 
                            color="primary"
                            small
                            href="#"
                            @click.prevent="showAddNewEmail=true; addToEmail=true">
                            Add New Email
                        </v-btn>

                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs2 sm1>Cc</v-flex>
                    <v-flex xs10 text-xs-left>

                        <v-chip v-for="email in initEmailSendingData.ccEmails"
                            :key="email.email"
                            close
                            @input="removeCcEmail(email)"
                        >{{email.name}}<{{email.email}}></v-chip>
                        
                    </v-flex>
                    <v-flex offset-xs2 offset-sm1 xs4 >
                        <v-btn 
                            color="primary"
                            small
                            href="#"
                            @click.prevent="addCcEmail=true; showUserPicker=true">
                            Pick Exists User
                        </v-btn>
                        <v-btn 
                            color="primary"
                            small
                            href="#"
                            @click.prevent="showAddNewEmail=true; addCcEmail=true">
                            Add New Email
                        </v-btn>

                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs2 sm1>Subject</v-flex>
                    <v-flex xs10 sm11>
                        <v-text-field 
                            v-model="initEmailSendingData.subject" 
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs2 sm1>Content</v-flex>
                    <v-flex xs10 sm11>
                        <v-textarea
                        auto-grow
                        v-model="initEmailSendingData.content"
                        ></v-textarea>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs2 sm1>Attachments</v-flex>
                    <v-flex xs10 text-xs-left>

                        <v-chip v-for="attachment in initEmailSendingData.attachments"
                            :key="attachment.id"
                            close
                            @input="removeAttachment(attachment)"
                        >{{attachment.name}}</v-chip>
                        
                    </v-flex>
                </v-layout>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.native="onSendEmail">Send</v-btn>
                <v-btn color="info" @click.native="onCloseSendEmail">Close</v-btn>
                <!-- <v-btn color="green darken-1" flat="flat" @click.native="resetUser">Reset</v-btn> -->

                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
        <v-dialog v-model="showUserPicker" width="400" height="400">
            <ctlUserPicker roles="['csrep', 'insideRep', 'salesrep']"
                @onCloseUserPicker = "onCloseUserPicker"
                @onUserPicked = "onUserPicked"
            ></ctlUserPicker>
        </v-dialog>
        <v-dialog v-model="showAddNewEmail" width="400" height="400">
            <ctlSendEmailAddNewEmail
                @onAddNewEmail="onUserPicked"
                @onCloseAddNewEmail="onCloseUserPicker"
            ></ctlSendEmailAddNewEmail>
        </v-dialog>
        <!-- {{initEmailSendingData}} -->

    </div>
</template>
<script>
import ctlUserPicker from './ctlUserPicker'
import ctlSendEmailAddNewEmail from './ctlSendEmailAddNewEmail'
import { mapActions } from 'vuex'

export default {
    props: ['initEmailSendingData'],
    components: {
        ctlUserPicker: ctlUserPicker,
        ctlSendEmailAddNewEmail: ctlSendEmailAddNewEmail,
    },
    data () {
        return {
            emailFormValid: false,
            userPickerRoles: ['csrep', 'insideRep', 'salesrep'],
            rules: {
                required: v => !!v || "This field is required"
            },
            //show user picker
            addToEmail: false,
            addCcEmail: false,
            //show add new popup
            addToEmailNew: false,
            addCcEmailNew: false,
            showUserPicker: false,
            showAddNewEmail: false,
        }
    },
    computed: {
        title () {
            return "Send Quote Email"
        },
        // showUserPicker () {
        //     return this.addToEmail || this.addCcEmail
        // },
        // showAddNewEmail () {
        //     return this.addToEmailNew || this.addCcEmailNew
        // },
    },
    methods: {
        ...mapActions('quoteWorkflow', [
            'sendEmail',
        ]),
        async onSendEmail () {
            var result = await this.sendEmail(this.initEmailSendingData)
            if (result == "success") {
                this.$emit('quoteEmailSent')
            }
        },
        onCloseSendEmail () {
            this.$emit('quoteEmailSentPopupClose')
        },
        removeToEmail(emailToRemove) {
            console.log(emailToRemove)
            const idx = this.initEmailSendingData.toEmails.indexOf(emailToRemove)
            if(idx > -1) {
                this.initEmailSendingData.toEmails.splice(idx, 1)
            }
        },
        removeCcEmail(emailToRemove) {
            console.log(emailToRemove)
            const idx = this.initEmailSendingData.ccEmails.indexOf(emailToRemove)
            if(idx > -1) {
                this.initEmailSendingData.ccEmails.splice(idx, 1)
            }
        },
        removeAttachment(attachment) {
            console.log(attachment)
            const idx = this.initEmailSendingData.attachments.indexOf(attachment)
            if(idx > -1) {
                this.initEmailSendingData.attachments.splice(idx, 1)
            }
        },
        onUserPicked(user) {
            if(this.addToEmail || this.addToEmailNew) {
                if(this.initEmailSendingData.toEmails.some(v=>v.email == user.email)) {
                    alert('this email exists already')
                    return
                }
                this.initEmailSendingData.toEmails = [...this.initEmailSendingData.toEmails, 
                    {name: user.name, email: user.email}]
            }
            if(this.addCcEmail || this.addCcEmailNew) {
                if(this.initEmailSendingData.ccEmails.some(v=>v.email == user.email)) {
                    alert('this email exists already')
                    return
                }
                this.initEmailSendingData.ccEmails = [...this.initEmailSendingData.ccEmails, 
                    {name: user.name, email: user.email}]
            }
            this.onCloseUserPicker()
        },
        onCloseUserPicker() {
            this.addToEmail = false
            this.addCcEmail = false
            this.showUserPicker =false
            this.showAddNewEmail = false
        }
    },
}
</script>
